export default __webpack_public_path__ + "static/media/1.7f108c2f.webp";